<template>
  <div>
    <b-button
      title="RRHD Conversion"
      @click="toggleRRHD()"
      :variant="drawPolygon ? 'primary' : 'outline-dark'"
      :class="drawPolygon ? '' : 'menu-bg-blue-transparent'"
    >
      <fa :icon="['fas', 'exchange-alt']" size="lg" />
    </b-button>
    <span
      :class="user.org == 3 ? 'areaSelectedCust px-2' : 'areaSelected px-2'"
      v-if="drawPolygon"
      >{{ measurement }} sq mi</span
    >
    <b-modal
      id="DownloadModal"
      title="Export Map area to mathworks *rrhd format"
      content-class="menu-bg-blue-transparent-modal"
      header-close-variant="light"
      centered
      hide-footer
      size="lg"
      @shown="displayHistory"
      @hidden="removeFeature"
    >
      <div class="inline-block">
        <b-container>
          <b-row>
            <b-col class="col-sm-6">
              <b-form-input
                type="text"
                autocomplete="off"
                v-model="fileName"
                placeholder="Enter file name"
              />
            </b-col>
            <b-col class="col-sm-6 pl-4">
              <b-button variant="primary" @click="exportRRHD($event)"
                >Export to RRHD</b-button
              >
            </b-col>
          </b-row>
          <b-row class="mt-4">
            <b-col>
              <h4>Generated Files</h4>
              <vue-bootstrap4-table
                :rows="rows"
                :columns="columns"
                :config="config"
                :classes="classes"
              >
                <template slot="download" slot-scope="props">
                  <fa
                    :icon="['fas', 'download']"
                    @click="
                      downloadFile(props.row.file_uid, props.row.friendly_name)
                    "
                  />
                </template>
              </vue-bootstrap4-table>
            </b-col>
          </b-row>
        </b-container>
      </div>
    </b-modal>
  </div>
</template>

<script>
import Style from 'ol/style/Style'
import {Vector as VectorSource} from 'ol/source'
import {Tile as TileLayer, Vector as VectorLayer} from 'ol/layer'
import Stroke from 'ol/style/Stroke'
import Fill from 'ol/style/Fill'
import {Draw, Snap} from 'ol/interaction'
import CircleStyle from 'ol/style/Circle'
import Polygon from 'ol/geom/Polygon'
import axios from 'axios'
import VueBootstrap4Table from 'vue-bootstrap4-table'
import WKT from 'ol/format/WKT'
import {fromExtent} from 'ol/geom/Polygon'
import LineString from 'ol/geom/LineString'
import {getArea, getLength} from 'ol/sphere'
export default {
  name: 'MMP_Rivian_RRHD',
  components: {
    VueBootstrap4Table
  },
  props: ['map', 'user'],
  data() {
    return {
      drawPolygon: null,
      measurement: 0.0,
      fileName: null,
      polygonWkt: null,
      rows: [],
      classes: {
        table: {
          'menu-bg-blue-transparent': true
        }
      },
      columns: [
        {
          label: 'File Name',
          name: 'friendly_name'
        },
        {
          label: 'Download Date',
          name: 'create_date'
        },
        {
          label: 'download',
          name: 'download'
        }
      ],
      config: {
        checkbox_rows: false,
        rows_selectable: true,
        card_mode: false,
        global_search: {
          placeholder: 'Search...',
          visibility: true,
          showClearButton: true,
          searchOnPressEnter: true
        },
        highlight_row_hover_color: '#4a4a4a',
        show_refresh_button: false,
        show_reset_button: false
      },
      vectorLayer: null
    }
  },
  methods: {
    addInteraction() {
      let snap
      const source = new VectorSource()
      this.vectorLayer = new VectorLayer({
        source: source,
        style: new Style({
          fill: new Fill({
            color: 'rgba(255, 255, 255, 0.6)'
          }),
          stroke: new Stroke({
            color: '#ffcc33',
            width: 4
          }),
          image: new CircleStyle({
            radius: 7,
            fill: new Fill({
              color: '#ffcc33'
            })
          })
        })
      })
      this.draw = new Draw({
        source: source,
        type: 'Polygon'
      })
      this.map.addInteraction(this.draw)
      snap = new Snap({source: source})
      this.map.addInteraction(snap)
      this.vectorLayer.setZIndex(4)
      this.$emit('getVectorlayer', this.vectorLayer)
      let self = this
      let listener
      this.draw.on('drawstart', function (evt) {
        listener = evt.feature.getGeometry().on('change', function (evt) {
          var geom = evt.target
          self.measurement = self.formatArea(geom).toFixed(2)
        })
      })
      this.draw.on('drawend', function (evt) {
        const format = new WKT()
        self.polygonWkt = null
        self.polygonWkt = format.writeGeometry(
          fromExtent(evt.feature.getGeometry().getExtent()),
          {
            dataProjection: 'EPSG:4326',
            featureProjection: 'EPSG:3857'
          }
        )
        if (self.measurement <= 100) {
          self.$bvModal.show('DownloadModal')
        } else {
          self.$bvToast.toast(`Please Zoom in to select map area. `, {
            autoHideDelay: 5000,
            title: 'Please select area within 100 mile radius.',
            toaster: 'b-toaster-top-right'
          })
          self.removeFeature()
        }
      })
    },
    toggleRRHD() {
      this.drawPolygon = !this.drawPolygon
      if (this.drawPolygon) {
        this.addInteraction()
      } else {
        this.removeFeature()
      }
    },
    formatLength(line) {
      var length = getLength(line)
      var output
      var meters
      var feet

      if (length > 100) {
        meters = Math.round((length / 1000) * 100) / 100
        feet = Math.round((length / 1609.344) * 100) / 100
      } else {
        meters = Math.round(length * 100) / 100
        feet = Math.round(length * 3.281 * 100) / 100
      }
      output = [meters, feet]
      return output
    },
    formatArea(polygon) {
      const area = getArea(polygon) //distance between the points (in meters).
      let output
      if (area > 10000) {
        output = Math.round((area / 1000000) * 100) / 100
      } else {
        output = Math.round(area * 100) / 100
      }
      return output * 0.621371 //conver to miles
    },
    exportRRHD(e) {
      if (sessionStorage.token) {
        if (this.fileName == null || this.fileName == ' ') {
          this.$bvToast.toast('File name required .', {
            autoHideDelay: 7000,
            title: 'Export to RRHD Error',
            toaster: 'b-toaster-top-right'
          })
        } else {
          axios
            .get(process.env.API_LOCATION + '/api/rivian_rrhd/exportRRHD', {
              headers: {
                'x-auth-token': sessionStorage.token,
                'Content-Type': 'multipart/form-data;'
              },
              params: {
                WKTCoord: this.polygonWkt,
                UserID: this.user.id,
                FriendlyName: this.fileName
              }
            })
            .then(response => {
              if (response.errors) {
                console.log(response.errors)
              } else {
                this.clearLayer()
                this.$bvToast.toast('File download in progress.', {
                  autoHideDelay: 10000,
                  title: 'Download Status',
                  toaster: 'b-toaster-top-right'
                })
                window.setTimeout(() => {
                  this.downloadFile(response.data.id, this.fileName)
                  this.displayHistory()
                  this.fileName = null
                }, 10000)
              }
            })
            .catch(function (error) {
              console.log(error)
            })
        }
      } else {
        console.log('No User Token')
      }
    },
    displayHistory() {
      if (sessionStorage.token) {
        axios
          .get(process.env.API_LOCATION + '/api/rivian_rrhd/getHistory', {
            headers: {
              'x-auth-token': sessionStorage.token
            },
            params: {
              id: this.user.id
            }
          })
          .then(response => {
            this.rows = JSON.parse(response.data).sort(
              (a, b) =>
                new Date(b.create_date).getTime() -
                new Date(a.create_date).getTime()
            )
            this.dateFormat()
            if (response.errors) {
              console.log(response.errors)
            }
          })
          .catch(function (error) {
            console.log(error)
          })
      } else {
        console.log('No User Token')
      }
    },
    downloadFile(file_uid, friendly_name) {
      if (sessionStorage.token) {
        axios
          .get(process.env.API_LOCATION + '/api/rivian_rrhd/downloadFile', {
            headers: {
              'x-auth-token': sessionStorage.token
            },
            params: {
              id: file_uid,
              name: friendly_name
            }
          })
          .then(response => {
            this.$bvToast.toast('File downloaded successfully', {
              autoHideDelay: 1000,
              title: 'Download Status',
              toaster: 'b-toaster-top-right'
            })
          })
          .catch(function (error) {
            console.log(error)
          })
        this.displayHistory()
        this.fileName = null
      } else {
        console.log('No User Token')
      }
    },
    clearLayer() {
      this.map.removeLayer(this.vectorLayer)
    },
    removeFeature() {
      this.map.removeInteraction(this.draw)
      this.drawPolygon = false
      this.measurement = 0
      this.clearLayer()
    },
    dateFormat() {
      this.rows.forEach(file => {
        if (file.create_date) {
          let date = new Date(file.create_date)
          file.create_date = date
            .toLocaleString('en-US', {
              dateStyle: 'short',
              timeStyle: 'long'
            })
            .replace(',', '')
        }
      })
    }
  }
}
</script>
